import Block from './Block/Block';

import { Main } from '@/components/layouts/Containers';

import { houseAccordionContent, meta } from './HomeQRs.data';
import { mediaLinks } from '@/config/mediaLinks';

import styles from './HomeQRs.module.scss';

const HomeQRs = () => {
  return (
    <Main meta={meta}>
      <div className={styles.wrapper}>
        <section className={styles.content}>
          <h1>Дом</h1>

          {houseAccordionContent.map((block) => (
            <>
              <div className={styles.header}>
                <h2 className={styles.title}>{block.title}</h2>
                {block.additional && block.additional}
              </div>
              {block.offers.map((offer, index) => (
                <Block offer={offer} key={index} />
              ))}
            </>
          ))}
        </section>

        <aside className={styles.aside}>
          <span className={styles.title}>Будем рады вам помочь!</span>
          <p className={styles.subtitle}>Если остались вопросы, свяжитесь с нами</p>
          <p className={styles.additionalInfo}>
            По электронной почте:{' '}
            <a href={mediaLinks.support} target='_blank' rel='noreferrer'>
              sakhipoteka@mail.ru
            </a>
          </p>
          <a href={mediaLinks.support} className={styles.link} target='_blank' rel='noreferrer'>
            Тех. поддержка
          </a>
        </aside>
      </div>
    </Main>
  );
};

export default HomeQRs;
